import modalListTemplate from './view/modalList.html'

class reimburseDetailCtrl {
    constructor($scope, $uibModal, httpRequest, $state, $stateParams) {
        // 隐藏一二级菜单
        if ($state.current.name === 'workspace.item.reiburseInfo') {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        const { expenseId } = $stateParams
        $scope.ivatExpenseBillRMap = []
        $scope.reimburseFrom = []
        $scope.listdata = []

        httpRequest.get_dictByTypeArr(['ivat_inv_type']).then((res) => {
            $scope.dictionary = res.data.value
        })

        httpRequest.get_getProjectlistOfCurrentOrg().then(res => {
            $scope.projectList = res.data.value
            httpRequest.get_getExpenseDetailById({ expenseId }).then((res) => {
                if (res.data.success) {
                    $scope.reimburseFrom = res.data.value
                    $scope.projectList.forEach(item => {
                        if ($scope.reimburseFrom.projectId === item.projectId) {
                            $scope.reimburseFrom.projectName = item.projectName
                        }
                    })
                    $scope.listdata = res.data.value.ivatExpenseBillRList
                    const map1 = res.data.value.ivatExpenseBillRMap
                    for (const item in map1) {
                        const obj = {
                            title: item,
                            list: map1[item],
                        }
                        $scope.ivatExpenseBillRMap.unshift(obj)
                    }
                    // console.log("属性：" + key + ",值：" + map[key]);
                }
            })
        })
        // 查询报销类型
        $scope.reimburseType = []
        $scope.smallType = []
        httpRequest.get_getIvatBxPzDTOList(true).then((res) => {
            const allType = res.data.value
            for (let i = 0; i < allType.length; i++) {
                const obj = {
                    enumName: allType[i].expenseName,
                    enumCode: allType[i].confId,
                }
                for (let j = 0; j < allType[i].mxList.length; j++) {
                    const obj2 = {
                        enumName: allType[i].mxList[j].expenseName,
                        enumCode: allType[i].mxList[j].confId,
                    }
                    $scope.smallType.push(obj2)
                }
                $scope.reimburseType.push(obj)
            }
        })
        $scope.showDetail = function (clickItem) {
            let currentList = []// 当前顺序的票面列表
            for (let j = 0, len = $scope.ivatExpenseBillRMap.length; j < len; j++) {
                currentList = currentList.concat($scope.ivatExpenseBillRMap[j].list ? $scope.ivatExpenseBillRMap[j].list : [])
            }
            $uibModal.open({
                template: modalListTemplate,
                controller: 'modalListCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail collection-invoice-detail',
                resolve: {
                    items1() {
                        const data = {
                            modalListData: currentList,
                            currentInvoicId: clickItem.invoiceId,
                        }
                        return data
                    },
                },
            })
        }
        $scope.imgPreview = function (item) {
            $uibModal.open({
                templateUrl: 'previewImg.html',
                controller: ['$scope', '$uibModalInstance', 'hasPDFReader', function ctrl(scope, uibModalInstance, hasPDFReader) {
                    scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${item.storageKey}`
                    scope.fileType = item.fileType
                    if (hasPDFReader()) {
                        scope.canShowPDF = true
                    }
                    scope.cancel = function cancel() {
                        uibModalInstance.close()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
                backdrop: 'static',
            })
        }
        $scope.fileDown = function (item) {
            window.open(`${host.etcloudIvatApp}expense/ivatExpense/downloadOtherInvoiceFileById?fileId=${item.storageKey}&accessToken=${localStorage.getItem('id_token')}`)
        }
    }
}
reimburseDetailCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', '$state', '$stateParams']
export default reimburseDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/reimburseDetailCtrl.js